module.exports = __webpack_public_path__ + "img/sgh.70a6d503.jpg";